import { privacyEffectiveDate, privacySections } from "../content/privacy";

export function PrivacyPage() {
  return (
    <section>
      <div className="page-intro">
        <p className="eyebrow">Legal</p>
        <h1 className="section-title">Privacy policy</h1>
        <p className="muted">Effective {privacyEffectiveDate}</p>
      </div>
      {privacySections.map((section) => {
        const paragraphs = Array.isArray(section.body)
          ? section.body
          : [section.body];
        return (
          <article key={section.heading} className="privacy-section">
            <h2>{section.heading}</h2>
            {paragraphs.map((paragraph) => (
              <p key={paragraph.slice(0, 48)} className="muted">
                {paragraph}
              </p>
            ))}
          </article>
        );
      })}
    </section>
  );
}
